module.exports = __webpack_public_path__ + "images/interview-Apple-2.svg";